import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=6271126f&scoped=true&"
import script from "./Template3.vue?vue&type=script&lang=js&"
export * from "./Template3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271126f",
  null
  
)

export default component.exports